/**
 * DRP 추출기가 의존하는 보고서 제목·열 이름 상수(spec 설계 결정 5 — "상수 한 곳").
 *
 * 비교는 모두 **공백 제거 후 포함(includes)** 이다(LLM이 `문제요약`으로 붙여 써도 찾도록).
 * cmm_2 프롬프트 출력 예시가 이 문자열을 정한다(현재-프롬프트.md). 프롬프트를 바꾸면
 * 여기만 고치면 된다. 10/18까지 프롬프트는 동결(Phases).
 */

/** 공백만 제거(가운뎃점 `·`·슬래시 `/`·괄호는 유지). */
export const normalizeForMatch = (s: string): string => (s ?? "").replace(/\s+/g, "");

/** DRP 표를 여는 h3 제목(공백 제거 후 포함 비교). */
export const DRP_HEADING = "약물관련문제(DRP)";
/** 약사 확인·교육 표를 여는 h3 제목. */
export const EDUCATION_HEADING = "약사확인·교육";
/** 목록 형식(예비)을 여는 h2 제목. */
export const LIST_HEADING = "약물관련문제목록";

/** 열 머리 이름(공백 제거 후 포함 비교). severity는 이모지 열. */
export const COLUMN = {
  no: "#",
  severity: "🚦",
  type: "유형",
  drpSummary: "문제요약",
  educationSummary: "확인/교육내용",
} as const;

/** 출력 상한(서버 DTO와 맞춤, 프론트는 코드포인트 단위로 더 엄격하게 절단). */
export const LIMITS = {
  maxRows: 50,
  summary: 1000,
  type: 50,
  no: 10,
} as const;
